import { createContext, useContext } from 'react';

export type CustomizationTrackingValues = Record<
  string,
  string | number | boolean | undefined | null
>;

interface BundleTrackingCustomization {
  getView?(): Promise<CustomizationTrackingValues>;
  getProductClick?(): Promise<CustomizationTrackingValues>;
}

const bundleTrackingCustomization = createContext<BundleTrackingCustomization>(
  {},
);

export const BundleTrackingCustomizationProvider =
  bundleTrackingCustomization.Provider;

const defaultContextValue: Required<BundleTrackingCustomization> = {
  getView: () => Promise.resolve({}),
  getProductClick: () => Promise.resolve({}),
};

export const useTrackingCustomization =
  (): Required<BundleTrackingCustomization> => {
    const context = useContext(bundleTrackingCustomization) || {};

    return {
      ...defaultContextValue,
      ...context,
    };
  };
